module.exports = "https://static-production.npmjs.com/c9e19250d48d66f0e9c70c9b3991bbdb.png";